import { SALON_DESK_APPOINTMENTS } from '@/lib/salonDeskConfig'

const ERP_STATUS_LABELS = {
  scheduled: 'Scheduled',
  confirmed: 'Confirmed',
  checked_in: 'Checked in',
  in_chair: 'In chair',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No show',
}

/** Plain labels for Salon Desk — Booked · Arrived · Done · Cancelled */
const DESK_STATUS_LABELS = {
  scheduled: 'Booked',
  confirmed: 'Booked',
  checked_in: 'Arrived',
  in_chair: 'Arrived',
  completed: 'Done',
  cancelled: 'Cancelled',
  no_show: 'Cancelled',
}

/**
 * @param {string | null | undefined} status
 */
export function formatAppointmentStatus(status) {
  if (!status) {
    return 'Unknown'
  }

  const labels =
    SALON_DESK_APPOINTMENTS.lite && SALON_DESK_APPOINTMENTS.plainStatusLabels
      ? DESK_STATUS_LABELS
      : ERP_STATUS_LABELS

  return labels[status] ?? status.replace(/_/g, ' ')
}
